import { useEffect, useState } from 'react';

interface LoadingOverlayProps {
  isVisible: boolean;
  theme: 'dark' | 'light';
  status: string;
}

export default function LoadingOverlay({ isVisible, theme, status }: LoadingOverlayProps) {
  const [dots, setDots] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setDots((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  const isDark = theme === 'dark';

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className={`flex flex-col items-center gap-4 px-8 py-6 rounded-3xl ${
          isDark ? 'bg-[#1C1D21]' : 'bg-white'
        }`}
      >
        {/* Spinner */}
        <div className="relative w-12 h-12">
          <div
            className={`absolute inset-0 rounded-full border-[3px] ${
              isDark ? 'border-white/10' : 'border-neutral-200'
            }`}
          />
          <div
            className={`absolute inset-0 rounded-full border-[3px] border-t-transparent animate-spin ${
              isDark ? 'border-[#F5F5F7]' : 'border-neutral-900'
            }`}
          />
        </div>

        {/* Status */}
        <div className="text-center">
          <p
            className={`text-[15px] font-semibold ${
              isDark ? 'text-[#F5F5F7]' : 'text-neutral-900'
            }`}
          >
            {status}
            {'.'.repeat(dots)}
          </p>
          <p
            className={`text-[13px] mt-1 ${
              isDark ? 'text-[#6E6E73]' : 'text-neutral-400'
            }`}
          >
            This will only take a moment
          </p>
        </div>
      </div>
    </div>
  );
}